import { LOCAL_STORAGE } from '../constants/localStorage'

class Service {
  get(key: string): string | null {
    return localStorage.getItem(`${LOCAL_STORAGE.key}/${key}`)
  }

  set(key: string, value: string | object) {
    if (typeof value === 'string') {
      localStorage.setItem(`${LOCAL_STORAGE.key}/${key}`, value)
    } else {
      const json = JSON.stringify(value)
      localStorage.setItem(`${LOCAL_STORAGE.key}/${key}`, json)
    }
  }

  remove(key: string) {
    localStorage.removeItem(`${LOCAL_STORAGE.key}/${key}`)
  }

  clear() {
    localStorage.clear()
  }
}

export const LocalStorageService = new Service()
